import { render, staticRenderFns } from "./headerText.vue?vue&type=template&id=1370df76&scoped=true&"
import script from "./headerText.vue?vue&type=script&lang=js&"
export * from "./headerText.vue?vue&type=script&lang=js&"
import style0 from "./headerText.vue?vue&type=style&index=0&id=1370df76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370df76",
  null
  
)

export default component.exports